module.exports = window["__sharedReduxSaga"];